import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-element" }
const _hoisted_2 = ["tabindex"]

import SvgDisplay from './SvgDisplay.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationBack',
  props: {
    disabled: { type: Boolean }
  },
  emits: ["onClicked"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "content",
      tabindex: _ctx.disabled ? -1 : 0,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClicked'))),
      onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onClicked')))
    }, [
      _createVNode(SvgDisplay, {
        src: "Icon-Chevron-Left-Medium",
        class: _normalizeClass(["arrow", { disabled: _ctx.disabled }])
      }, null, 8, ["class"])
    ], 40, _hoisted_2)
  ]))
}
}

})